import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import moment from "moment";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { EventBus } from "../../Controls/EventBus";
import { TableauDto } from "../../../dto/GenApi.iNotPaie.Dto/TableauDto";
import { ExerciceDto } from "../../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import EventConstants from "../../Controls/EventConstants";

@Component
export default class ModalEditionListeVariables extends Vue {
	public startYear: number = parseInt(moment.utc().format("YYYY"));
	public startMonth = 3;
	public listeAnnee: number[] = [];
	public exercices: ExerciceDto[] = [];
	public exercicesFiltred: ExerciceDto[] = [];
	public selectedExercice?: ExerciceDto = undefined;
	public dataReady = true;

	public mounted(): void {
    	this.initConstantes();
    	EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
    		this.initConstantes();
    	});
	}

	public initConstantes(): void {
    	ServicesFactoryInstance.ExercicesService.getExercices(data => {
    		this.exercices = data;
    		this.doFilter();
    		this.listeAnnee = this.exercices.map(e => e.Annee).filter((value, index, self) => self.indexOf(value) == index).sort((a, b) => b - a);
		});
	}

	public doFilter(): void {
    	this.exercicesFiltred = this.exercices.filter(e => e.Annee == this.startYear).sort((a, b) => b.Mois - a.Mois);
    	this.selectedExercice = this.exercicesFiltred[0];
	}

	public selectExercice(exercice: ExerciceDto): void {
    	this.selectedExercice = exercice;
    	this.$forceUpdate();
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	public Init(tableau: TableauDto): void {
		if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.PeriodeActive) {
    		this.startMonth = ParametresInstance.societeCourante.PeriodeActive.getUTCMonth();
    		this.startYear = ParametresInstance.societeCourante.PeriodeActive.getUTCFullYear();
    	}
    	this.doFilter();
    	this.$forceUpdate();
	}

	public annuler(): void {
    	$("#modalEditionListeVariables").modal("hide");
	}

	public LancerEdition(): void {
    	$("#modalEditionListeVariables").modal("hide");
    	this.$emit("openListeVariables", this.selectedExercice);
	}
}



// WEBPACK FOOTER //
// ./src/components/tableaux/modalEditionListeVariables/modalEditionListeVariables.ts